import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWatch, useFormContext } from 'react-hook-form';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import TextFieldHookForm from 'components/Common/InputBox/TextFieldHookForm';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import * as invitationActions from 'redux/ducks/Employee/InvitationDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import { getHostDomain } from 'utils/common';

const OTP_PERIOD_IN_SECOND = 180;

export const InviteIdForm = () => {
  const dispatch = useDispatch();
  const [authKey, setAuthKey] = useState(0);
  const { duplicateIdCheck, authMessage, otpCheckMessage, isSendOtp, isOtpSuccess, employeeVo, incorrectOTPcount } =
    useSelector(state => state.invitation);
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const userId = useWatch({ name: 'userId' });
  const getAuthMessage = () => {
    return authMessage.isSuccess ? (
      <div className="input-add-exp">
        <span className="text color-primary">{i18n.t(authMessage.message, { userId: getValues('userId') })}</span>
      </div>
    ) : authMessage.message ? (
      <div className="input-add-exp">
        <span className="text color-warning">{i18n.t(authMessage.message)}</span>
      </div>
    ) : (
      <div className="input-add-exp">
        <span className="text">{i18n.t('MB_T_USE_ID_GUIDE')}</span>
      </div>
    );
  };
  const getUserIdPlaceHolder = () => {
    return employeeVo.emailAddr ? `abc${employeeVo.emailAddr}` : `abc${getHostDomain()}`;
  };

  useEffect(() => {
    if (duplicateIdCheck && userId !== employeeVo.userId) {
      dispatch(invitationActions.initAuthentication());
    }
  }, [userId, duplicateIdCheck]);
  useEffect(() => {
    if (incorrectOTPcount >= 4) {
      dispatch(invitationActions.setSendOtp(true));
      setValue('otp', '');
      dispatch(invitationActions.resetCheckOTPcount());
      dispatch(
        alertActions.open({
          message: ['MB667'],
        }),
      );
    }
  }, [incorrectOTPcount]);

  return (
    <>
      <TblRow>
        <TblRowHeader rowHeader="ID" isRequired />
        <TblRowTail
          formClass="form-field-multi"
          buttonChildren={
            <>
              <Button
                componentType="solid"
                className="primary ie-btn"
                label={i18n.t('MB_T_COMMON_DOUBLECHECK')}
                disabled={isOtpSuccess || isSendOtp}
                onClick={() => {
                  if (errors.userId) {
                    dispatch(invitationActions.setAuthMessage(errors.userId));
                  } else if (getValues('userId')) {
                    dispatch(invitationActions.duplicateIdCheck({ query: getValues('userId') }));
                  }
                }}
              />
              <Button
                componentType="solid"
                className="primary ie-btn"
                disabled={!duplicateIdCheck || isOtpSuccess || isSendOtp}
                label={i18n.t('MB_T_OTP_NUMBER_SEND')}
                onClick={() => {
                  const payload = {
                    compCd: employeeVo.compCd,
                    locale: 'ko',
                    option: 'link',
                    optionValue: getValues('userId'),
                  };
                  setAuthKey(Math.random());
                  dispatch(invitationActions.createOtp(payload));
                }}
              />
            </>
          }
        >
          <TextFieldHookForm
            name="userId"
            className="type-full"
            maxLength={50}
            disabled={isOtpSuccess}
            placeholderLabel={getUserIdPlaceHolder()}
            useExpLabel={false}
            error={!authMessage?.isSuccess && authMessage.message}
          />
          {!isOtpSuccess && getAuthMessage()}
        </TblRowTail>
      </TblRow>
      <TblRow key={authKey}>
        <TblRowHeader rowHeader={i18n.t('MB_T_OTP_NUMBER')} isRequired />
        <TblRowTail
          formClass="form-field-multi"
          buttonChildren={
            <Button
              componentType="solid"
              className="primary "
              disabled={!isSendOtp || isOtpSuccess}
              label={i18n.t('MB_T_OTP_NUMBER_OK')}
              onClick={() => {
                const payload = { epid: getValues('userId'), opt: getValues('otp') };
                dispatch(invitationActions.checkOtp(payload));
              }}
            />
          }
        >
          <TextFieldHookForm
            componentType={isSendOtp ? 'inputTimer' : 'input'}
            timerCount={`${OTP_PERIOD_IN_SECOND}`}
            placeholderLabel={i18n.t('MB_T_OTP_NUMBER')}
            name="otp"
            className="type-full"
            maxLength={50}
            disabled={isOtpSuccess}
            timerCallback={() => {
              dispatch(invitationActions.setSendOtp(isSendOtp));
            }}
            error={otpCheckMessage?.errorCode}
          />
          {otpCheckMessage?.errorCode && (
            <div className="input-add-exp">
              <span className="text color-warning">{i18n.t(otpCheckMessage.errorCode)}</span>
            </div>
          )}
        </TblRowTail>
      </TblRow>
    </>
  );
};
InviteIdForm.propTypes = {};
InviteIdForm.defaultProps = {};
export default InviteIdForm;
